import { Link } from 'react-router-dom';
import { Layout } from '../components/Layout';
import { CatalogView } from '../components/CatalogView';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { HelpCircle } from 'lucide-react';

function LoggedOutHero() {
  return (
    <section className="bg-[#1E3A5F] relative overflow-hidden">
      <div className="absolute top-0 right-0 w-60 h-60 bg-[#C9956C]/20 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-40 h-40 bg-white/5 rounded-full blur-3xl" />
      <div className="relative z-10 max-w-xl px-4 md:px-6 py-5 md:py-6">
        <div className="flex items-center gap-2 mb-2">
          <span className="px-2 py-0.5 rounded-full bg-white/10 border border-white/20 text-white/90 text-xs font-bold uppercase tracking-wider">
            Australia's Marketplace
          </span>
        </div>
        <h1 className="text-2xl md:text-3xl lg:text-4xl font-black tracking-tighter text-white mb-2">
          Find What You <span className="text-[#C9956C]">Want</span>.<br />
          Sell What You <span className="text-[#E5DDD3]">Have</span>.
        </h1>
        <p className="text-xs md:text-sm text-white/70 mb-4 max-w-lg">
          Browse items for sale near you, or post what you're looking for and let sellers come to you.
        </p>
        <div className="flex flex-wrap gap-2">
          <Link to="/register">
            <Button size="sm" className="bg-[#C9956C] hover:bg-[#B8845B] text-white rounded-full px-4 h-8 text-xs" data-testid="get-started-btn">
              Get Started Free
            </Button>
          </Link>
          <Link to="/login">
            <Button size="sm" variant="outline" className="border-white/30 text-white hover:bg-white/10 rounded-full px-4 h-8 text-xs">
              Sign In
            </Button>
          </Link>
          <Link to="/help">
            <Button size="sm" variant="outline" className="border-white/30 text-white hover:bg-white/10 rounded-full px-4 h-8 text-xs">
              <HelpCircle className="w-3.5 h-3.5 mr-1.5" />
              Help Center
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}

export default function HomePage() {
  const { user } = useAuth();

  return (
    <Layout>
      <div className={`w-full ${user ? '-mt-4 md:-mt-6' : '-mt-5 md:-mt-8'}`}>
        <CatalogView heroSlot={!user && <LoggedOutHero />} />
      </div>
    </Layout>
  );
}
